import type { BrandName } from 'packages/types/brand-name';
import { telephoneNumbers } from '../const/telephoneNumbers';
import { siteLinks } from '../const/siteLinks';

export const getContactNumberByBrand = (
  brand: BrandName | undefined
): string => {
  switch (brand) {
    case 'BASC':
      return '03330 30 82 05';
    case 'GCCF':
      return '03330 30 90 30';
    case 'Dog Friendly':
      return '03330 30 82 92';
    case 'Crufts':
      return '03330 30 82 89';
    case 'Insure K9':
      return '03330 30 82 08';
    case 'RDA':
      return '03330 30 83 88';
    case 'Clegg Gifford':
      return '01481 72 89 87';
    case 'CTM':
      return '03330 30 83 62';
    case 'Service Dogs':
      return '';
    case 'Puppies':
      return '03330 30 83 65';
    case 'Pets4Homes':
      return '03330 30 83 78';
    default:
      return telephoneNumbers.newSales;
  }
};

export const getQuoteUrlByBrand = (
  brand: BrandName | undefined,
  ctaLink?: string
): string => {
  const baseQuoteUrl = ctaLink || siteLinks.quoteAndBuy;
  let trackingParam = '';

  switch (brand) {
    case 'BASC':
      trackingParam = '?affid=17969&dog';
      break;
    case 'GCCF':
      trackingParam = '?affid=20275&cat';
      break;
    case 'Dog Friendly':
      trackingParam = '?affid=104408&dog';
      break;
    case 'Crufts':
      trackingParam = '?pc=crufts';
      break;
    case 'Insure K9':
      trackingParam = '';
      break;
    case 'RDA':
      trackingParam =
        '?affid=08D8E393-BB21-44EC-8FF4-1CDB91CB5EC9&_gl=1*jaaq9b*_gcl_aw*R0NMLjE2OTcwMzI5ODAuQ2owS0NRandqNW1wQmhESkFSSXNBT1ZqQmRvTG9ZRkwwS3ViRWpCYkJXRWM3T3R3ekI3N2F6TVRlTjV3V0xUdEVNU3N4OWFEVTdoMzNxZ2FBa1FURUFMd193Y0I.*_gcl_dc*R0NMLjE2OTcwMzI5ODAuQ2owS0NRandqNW1wQmhESkFSSXNBT1ZqQmRvTG9ZRkwwS3ViRWpCYkJXRWM3T3R3ekI3N2F6TVRlTjV3V0xUdEVNU3N4OWFEVTdoMzNxZ2FBa1FURUFMd193Y0I.*_gcl_au*MjA5MDcwMTcyMy4xNjkxNDA0MzIxLjgxMTI2ODY5MC4xNjk1ODk4NDEyLjE2OTU4OTg0MTI';
      break;
    case 'Clegg Gifford':
      trackingParam = '?affid=185980';
      break;
    case 'CTM':
      trackingParam = '';
      break;
    case 'DogFest':
      trackingParam = '?utm_source=dogfest&utm_medium=website&utm_campaign=DF';
      break;
    case 'Pets4Homes':
      trackingParam = '?affid=191720';
      break;
    default:
      trackingParam = '';
      break;
  }

  return `${baseQuoteUrl}${trackingParam}`;
};
